<div class="text-center py-10">
  <span class="display-1 fe fe-inbox text-muted"></span>
  <h1 class="text-muted">
    {{title}}
  </h1>
  <p class="text-muted">
    {{subtitle}}
  </p>
</div>
